// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__28PlR","image":"Header_image__3WRuy","name":"Header_name__2fVe_","info":"Header_info__2PuYi","infoRow":"Header_infoRow__Mr2va"};